import { render } from "./PatientAuthorizedContacts.vue?vue&type=template&id=670fa680&ts=true"
import script from "./PatientAuthorizedContacts.ts?vue&type=script&lang=ts&external"
export * from "./PatientAuthorizedContacts.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__